export const PROJECT_ADMIN_ID = "d9f8f8e9-e9e0-4d4d-b8e8-d9f8f8e9e0d5";
export const PROJECT_CONTRIBUTOR_ID = "d9f8f8e9-e9e0-4d4d-b8e8-d9f8f8e9e0d6";
export const PROJECT_VIEWER_ID = "d9f8f8e9-e9e0-4d4d-b8e8-d9f8f8e9e0d4";
